/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cc_Step_TwoInputs */

const en_cc_step_two = /** @type {(inputs: Cc_Step_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open chrome://extensions, enable Developer mode, select Load unpacked, and choose the extracted folder.`)
};

const id_cc_step_two = /** @type {(inputs: Cc_Step_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka chrome://extensions, aktifkan Mode developer, lalu pilih Load unpacked dan folder hasil ekstrak.`)
};

/**
* | output |
* | --- |
* | "Open chrome://extensions, enable Developer mode, select Load unpacked, and choose the extracted folder." |
*
* @param {Cc_Step_TwoInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cc_step_two = /** @type {((inputs?: Cc_Step_TwoInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_Step_TwoInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cc_step_two(inputs)
	return en_cc_step_two(inputs)
});